<template>
    <v-app-bar style="z-index: 9999" color="white" app>
        <v-toolbar-title class="d-flex justify-center">
            <router-link to="/">
                <v-img
                    src="@/assets/header_logo.png"
                    max-width="200"
                    alt="Prospira Logo"
                ></v-img>
            </router-link>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-row
            align="center"
            justify="end"
            class="mr-1"
        >
            <router-link to="/about-us">
                <v-btn
                    text
                    class="hidden-sm-and-down"
                >
                    About Us
                </v-btn>
            </router-link>

            <router-link to="/careers">
                <v-btn
                    text
                    class="hidden-sm-and-down"
                >
                    Careers
                </v-btn>
            </router-link>

            <router-link to="/contact-us">
                <v-btn
                    text
                    class="hidden-sm-and-down"
                >
                    Contact Us
                </v-btn>
            </router-link>

            <router-link to="/leadership">
                <v-btn
                    text
                    class="hidden-sm-and-down"
                >
                    Leadership
                </v-btn>
            </router-link>

            <v-menu
                bottom
                left
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        class="d-md-none d-lg-none d-xl-none d-xxl-none"
                    >
                        <v-icon>mdi-menu</v-icon>
                    </v-btn>
                </template>

                <v-list>
                    <router-link
                        v-for="(item, i) in navigationItems"
                        :key="i"
                        :to="item.slug"
                        class="text-decoration-none"
                    >
                        <v-list-item>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                    </router-link>
                </v-list>
            </v-menu>

            <v-divider
            vertical
            ></v-divider>

            <v-btn
                color="#1877F2"
                text
                icon
                href="https://www.facebook.com/prospira.us"
                target="_blank"
            >
                <v-icon>mdi-facebook</v-icon>
            </v-btn>

            <v-btn
                color="#0a66c2"
                text
                icon
                href="https://www.linkedin.com/company/bridgestone-apm-company/"
                target="_blank"
            >
                <v-icon>mdi-linkedin</v-icon>
            </v-btn>
        </v-row>
    </v-app-bar>
</template>

<script>
export default {
    name: 'AppBar',
    data: () => ({
      navigationItems: [
        { title: 'About Us', slug: "/about-us" },
        { title: 'Careers', slug: "/careers" },
        { title: 'Contact Us', slug: "/contact-us" },
        { title: 'Leadership', slug: "/leadership" },
      ],
    }),
}
</script>